import { useAuthModal } from "../../../contexts/AuthModalContext";

export const Header = () => {
  const { showAuthModal } = useAuthModal();
  return (
    <header class="sticky top-0 z-50 backdrop-blur bg-neutral-50/85 dark:bg-neutral-900/85 border-b border-gray-200/70 dark:border-gray-700/60">
      <div class="max-w-5xl mx-auto flex items-center justify-between px-4 py-2.5">
        <a href="/" class="text-3xl font-bold text-neutral-700 dark:text-neutral-50" aria-label="!tldr home">
          !tldr
        </a>
        <nav class="flex items-center gap-4">
          <a
            href="/articles"
            class="hidden sm:inline text-sm font-medium text-gray-700 dark:text-gray-200 hover:underline"
            data-test-click="landing-nav-articles"
          >
            Articles
          </a>
          <a
            href="/authors"
            class="hidden sm:inline text-sm font-medium text-gray-700 dark:text-gray-200 hover:underline"
            data-test-click="landing-nav-authors"
          >
            Authors
          </a>
          <button
            type="button"
            onClick={() => showAuthModal("Sign in", "Welcome back. Sign in to pick up where you left off")}
            class="px-3.5 py-1.5 text-sm bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all"
            data-test-click="sign-in-landing-page"
          >
            Sign in
          </button>
        </nav>
      </div>
    </header>
  );
};
